var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 21,
    viewBox: "0 0 30 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 12H6C5.1 12 4.5 11.4 4.5 10.5C4.5 9.6 5.1 9 6 9H24C24.9 9 25.5 9.6 25.5 10.5C25.5 11.4 24.9 12 24 12Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 21H10.5C9.6 21 9 20.4 9 19.5C9 18.6 9.6 18 10.5 18H19.5C20.4 18 21 18.6 21 19.5C21 20.4 20.4 21 19.5 21Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 3H1.5C0.6 3 0 2.4 0 1.5C0 0.6 0.6 0 1.5 0H28.5C29.4 0 30 0.6 30 1.5C30 2.4 29.4 3 28.5 3Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.3aed7ae8.svg";
export { ForwardRef as ReactComponent };